module.exports = __webpack_public_path__ + "static/media/shavuot.5324ac84.svg";